"use client";

import React from "react";
import { Header } from "@/components/pages/Landings/Header";
import Footer from "@/components/pages/Landings/Footer";
import StartEarning from "@/components/pages/Landings/StartEarning";
import dynamic from "next/dynamic";
const LottieComponent = dynamic(() => import("@/components/Lottie/Lottie"), {
  ssr: false,
});
import { useTranslations } from "next-intl";

const HowDoesRewardsWorkPage = ({ session }: any) => {
  const t = useTranslations();

  if (session && session.provider === "credentials") return null;

  return (
    <div className="bg-[linear-gradient(219deg,_rgba(242,_121,_40,_0.10)_-0.42%,_rgba(242,_121,_40,_0.06)_-0.41%,_rgba(242,121,40,0.00)_78.67%)]">
      <Header />
      <div className="mx-auto max-w-[980px] px-[20px] w-full pt-[93px] md:pt-[156px] pb-[40px] md:pb-[96px] flex flex-col items-center justify-center gap-[64px]">
        <div className="flex flex-col md:flex-row items-center gap-[24px] mb-[44px]">
          <div className="border-[10px] md:border-[12px] border-primary-100 shrink-0 h-[60px] md:h-[80px] w-[60px] md:w-[80px] bg-primary-200 rounded-full flex items-center justify-center text-[24px] md:text-[36px] shadow-[0px_5.833px_21.875px_0px_rgba(14,9,7,0.11)]">
            🤔
          </div>
          <h1 className="text-[36px] md:text-[64px] text-center md:text-left font-bold leading-[36px] md:leading-[64px]">
            {t("HowDoesRewardsWork.title")}
          </h1>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-[96px] w-full items-stretch">
          <div className="flex flex-col gap-[16px] justify-center">
            <h2 className="text-[32px] leading-[38px] font-bold">
              {t("HowDoesRewardsWork.section1Title")}
            </h2>
            <p className="text-black-400 leading-[24px]">
              {t("HowDoesRewardsWork.section1Text1")}
              <br />
              <br />
              {t("HowDoesRewardsWork.section1Text2")}
            </p>
          </div>
          <div className="relative h-full w-full">
            <LottieComponent
              getAnimationData={() =>
                import("public/lottie/howDoesRewardsWork1.json")
              }
              id="howDoesRewardsWork1"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-[96px] w-full items-stretch">
          <div className="relative h-full w-full order-2 md:order-1">
            <LottieComponent
              getAnimationData={() =>
                import("public/lottie/howDoesRewardsWork2.json")
              }
              id="howDoesRewardsWork2"
            />
          </div>
          <div className="order-1 md:order-2 flex flex-col gap-[16px] justify-center">
            <h2 className="text-[32px] leading-[38px] font-bold">
              {t("HowDoesRewardsWork.section2Title")}
            </h2>
            <p className="text-black-400 leading-[24px]">
              <b>{t("HowDoesRewardsWork.section2Text1Bold")}</b>{" "}
              {t("HowDoesRewardsWork.section2Text1")}
              <br />
              <br />
              <b>{t("HowDoesRewardsWork.section2Text2Bold")}</b>{" "}
              {t("HowDoesRewardsWork.section2Text2")}
              <br />
              <br />
              {t("HowDoesRewardsWork.section2Text3")}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-[96px] w-full items-stretch">
          <div className="flex flex-col gap-[16px] justify-center">
            <h2 className="text-[32px] leading-[38px] font-bold">
              {t("HowDoesRewardsWork.section3Title")}
            </h2>
            <p className="text-black-400 leading-[24px]">
              {t("HowDoesRewardsWork.section3Text1")}{" "}
              <b>{t("HowDoesRewardsWork.section3Text1Bold")}</b>{" "}
              {t("HowDoesRewardsWork.section3Text2")}
              <br />
              <br />
              {t("HowDoesRewardsWork.section3Text3")}
            </p>
          </div>
          <div className="relative h-full w-full">
            <LottieComponent
              getAnimationData={() =>
                import("public/lottie/howDoesRewardsWork3.json")
              }
              id="howDoesRewardsWork3"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-[96px] w-full items-stretch">
          <div className="relative h-full w-full order-2 md:order-1">
            <LottieComponent
              getAnimationData={() =>
                import("public/lottie/howDoesRewardsWork4.json")
              }
              id="howDoesRewardsWork4"
            />
          </div>
          <div className="order-1 md:order-2 flex flex-col gap-[16px] justify-center">
            <h2 className="text-[32px] leading-[38px] font-bold">
              {t("HowDoesRewardsWork.section4Title")}
            </h2>
            <p className="text-black-400 leading-[24px]">
              {t("HowDoesRewardsWork.section4Text1")}{" "}
              <b>{t("HowDoesRewardsWork.section4Text1Bold")}</b>
              {t("HowDoesRewardsWork.section4Text2")}
              <br />
              <br />
              {t("HowDoesRewardsWork.section4Text3")}
              <br />
              <br />
              {t("HowDoesRewardsWork.section4Text4")}{" "}
              <b>{t("HowDoesRewardsWork.section4Text4Bold")}</b>
              {t("HowDoesRewardsWork.section4Text5")}
            </p>
          </div>
        </div>
      </div>
      <StartEarning
        title={t("Landing.startEarningTitle")}
        subtitle={t("Landing.startEarningSubTitle")}
        buttonLabel={t("Landing.signUp")}
      />
      <Footer />
    </div>
  );
};

export default HowDoesRewardsWorkPage;
